import styled from "styled-components";
import globalStyles from "../../constants/globalStyles/theme.json";

const { colors, spacing, breakpoints } = globalStyles;

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: ${spacing.space24};
  background-color: ${colors.primary.green};
  color: ${colors.primary.offWhite};
  display: flex;
  flex-direction: column;
  z-index: 1000;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Title = styled.h3`
  margin: 0;
  margin-left: ${spacing.space8};
  margin-top: ${spacing.space4};
`;

export const Body = styled.div``;

export const BodyText = styled.p``;

export const Content = styled.div`
  @media (min-width: ${breakpoints.l}) {
    margin: 0 auto;
  }
`;
